import type { PlaygroundSbtState } from './initial-state.js';
import type { PlaygroundSbt } from '../types.js';

const playgroundSbt = (state: PlaygroundSbtState, payload: PlaygroundSbt) => {
  return {
    ...state,
    loaded: true,
    data: payload,
  };
};

const eventReducers = { playgroundSbt };

export default eventReducers;
